import React,{useRef,useState,useEffect} from 'react'
import Select from "react-select";
import './auditDetails.css'
import { useDispatch } from 'react-redux';
import intomarkIcon from "../../../../assets/audit_assets/Audit_vendor/intomarkIcon.png"
import auditbreadcrumb_icon from "../../../../assets/audit_assets/Create_Audit/auditbreadcrumb_icon.png"
import mainIcon from "../../../../assets/audit_assets/audit_details/main_icon.png"
import download_icon from '../../../../assets/reUsableTemplates_assets/dowload_icon.png';
import delete_icon from '../../../../assets/reUsableTemplates_assets/delete_icon.png';
import selected_icon from '../../../../assets/reUsableTemplates_assets/selected_icon.png';
// import { GoChevronRight } from "react-icons/go";
import headerIcon from "../../../../assets/audit_assets/audit_details/headerIcon.png";
import { getClients} from './../../../../services/global_redux/globale_actions/Client.action';
import {createSingleAuditData, getUnitWiseVendor,getAudit,getClientWiseAudit,latestAuditDetails,filteredAuditDetails} from './../../../../services/audit_redux/audit_actions/Audit.action';
import branch_icon from "../../../../assets/audit_assets/audit_details/branch_icon.png";
import vendor_icon from "../../../../assets/audit_assets/audit_details/vendor_icon.png";
import { GoChevronDown , GoChevronRight} from "react-icons/go";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { useLocation } from 'react-router-dom';
function AuditDetails({ setLoading, showSnackbar }) {
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState("");
  const [activeTab, setActiveTab] = useState("In-audit");
  const [currentData,setCurrentData]= useState([])
  const [blurtable, setBlurtable]=useState('blurtable');
  const [clientIDs, setClientIDs] = useState([]);
  const [selectedClient , setSelectedClient]= useState('');
  const [selectedClientName , setSelectedClientName]= useState('');
  const dispatch = useDispatch();
  const [branches, setBranches] = useState([]);
  const [fromMonth, setFromMonth] = useState('');
  const [toMonth, setToMonth] = useState('');
  const [openInfoId, setOpenInfoId] = useState(null);
  const [tooltipPos, setTooltipPos] = useState(null);
  const tooltipRef = useRef(null);
  const addSingleData ={
    audit_name: "",
    client_id:"",
    start_period: "",
    end_period: "",
    templateId: [],
    unit_id_and_vendor_id: [],
    status:"Audit"
  }
  const closeScoreTooltip = () => {
    setOpenInfoId(null);
    setTooltipPos(null);
  };

  const handleScoreInfoClick = (event, rowId) => {
    event.stopPropagation();
    if (openInfoId === rowId) {
      closeScoreTooltip();
      return;
    }

    const rect = event.currentTarget.getBoundingClientRect();
    const estimatedHeight = 110;
    const gap = 6;
    const spaceBelow = window.innerHeight - rect.bottom;
    const placeAbove = spaceBelow < estimatedHeight + gap;
    const left = Math.min(Math.max(8, rect.left), window.innerWidth - 268);

    setTooltipPos({
      left,
      top: placeAbove ? rect.top - gap : rect.bottom + gap,
      placeAbove,
    });
    setOpenInfoId(rowId);
  };

  useEffect(() => {
    if (openInfoId == null) return;

    const handleClickOutside = (event) => {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target) &&
        !event.target.closest?.(".audit-info-icon")
      ) {
        closeScoreTooltip();
      }
    };

    const handleViewportChange = () => {
      closeScoreTooltip();
    };

    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", handleViewportChange, true);
    window.addEventListener("resize", handleViewportChange);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleViewportChange, true);
      window.removeEventListener("resize", handleViewportChange);
    };
  }, [openInfoId]);
  const [form, setForm] = useState(addSingleData);
  const [auditData, setAuditData] = useState([]);
  const [pendingData, setPendingData] = useState([]);
  const [openedData, setOpenedData] = useState([]);
  const [inProgressData, setInProgressData] = useState([]);
  const [reopenedData, setReopenedData] = useState([]);
  const [completedData, setCompletedData] = useState([]);
  const [expiredData, setExpiredData] = useState([]);
  const [header, setHeader] = useState([]);
  const headersByTab = {
    "In-audit": [
      { key: "audit_name", value: "Audit name", icon: headerIcon },
      { key: "vendor_name", value: "Vendor Name", icon: headerIcon },
      { key: "unit_id", value: "Branch Id", icon: headerIcon },
      { key: "unit_name", value: "Branche Name", icon: headerIcon },
      { key: "templateId", value: "Template Id's", icon: headerIcon },
      { key: "period", value: "Audit Period", icon: headerIcon },
      { key: "view", value: "Action", icon: headerIcon },
    ],
    Pending: [
      { key: "audit_name", value: "Audit name", icon: headerIcon },
      { key: "vendor_name", value: "Vendor Name", icon: headerIcon },
      { key: "unit_id", value: "Branch Id", icon: headerIcon },
      { key: "unit_name", value: "Branche Name", icon: headerIcon },
      { key: "templateId", value: "Template Id's", icon: headerIcon },
      { key: "period", value: "Audit Period", icon: headerIcon },
      { key: "work", value: "Action", icon: headerIcon },
    ],
    "In-Progress": [
      { key: "audit_name", value: "Audit name", icon: headerIcon },
      { key: "vendor_name", value: "Vendor Name", icon: headerIcon },
      { key: "unit_id", value: "Branch Id", icon: headerIcon },
      { key: "unit_name", value: "Branche Name", icon: headerIcon },
      { key: "templateId", value: "Template Id's", icon: headerIcon },
      { key: "period", value: "Audit Period", icon: headerIcon },
      { key: "work", value: "Action", icon: headerIcon },
    ],
    Completed: [
      { key: "audit_name", value: "Audit name", icon: headerIcon },
      { key: "vendor_name", value: "Vendor Name", icon: headerIcon },
      { key: "unit_id", value: "Branch Id", icon: headerIcon },
      { key: "unit_name", value: "Branche Name", icon: headerIcon },
      { key: "templateId", value: "Template Id's", icon: headerIcon },
      { key: "period", value: "Audit Period", icon: headerIcon },
      { key: "status", value: "status", icon: headerIcon },
      { key: "completed", value: "Action", icon: headerIcon },
    ],
    Expired: [
      { key: "audit_name", value: "Audit name", icon: headerIcon },
      { key: "vendor_name", value: "Vendor Name", icon: headerIcon },
      { key: "unit_id", value: "Branch Id", icon: headerIcon },
      { key: "unit_name", value: "Branche Name", icon: headerIcon },
      { key: "templateId", value: "Template Id's", icon: headerIcon },
      { key: "period", value: "Audit Period", icon: headerIcon },
      { key: "status", value: "status", icon: headerIcon },
      { key: "extend", value: "Action", icon: headerIcon },
    ],
  };
  useEffect(()=>{
    if (activeTab === "In-audit") setCurrentData(auditData);
    if (activeTab === "Pending") setCurrentData(pendingData);
    if (activeTab === "In-Progress") setCurrentData(inProgressData);
    if (activeTab === "Completed") setCurrentData(completedData);
    if (activeTab === "Expired") setCurrentData(expiredData);
    setHeader(headersByTab[activeTab]);
    setSearchQuery("");

  }, [activeTab, auditData, pendingData,inProgressData, completedData,expiredData]);
  const [minMonth, setMinMonth] = useState('');
  const [maxMonth, setMaxMonth] = useState('');
    
  const fetchData = async ()=>{
    try {
      const response = await dispatch(latestAuditDetails(selectedClient));
      if(response.success){
        setMinMonth(response.data.filter[0].start);
        setMaxMonth(response.data.filter[0].end);
        setAuditData(response.data.data.filter((item)=>item.status === "Audit" || item.status === "Vendor-In-Progress"));
        setPendingData(response.data.data.filter((item)=>item.status === "Audit-Pending"));
        setInProgressData(response.data.data.filter((item)=>item.status === "Auditor-In-progress"));
        setCompletedData(response.data.data.filter((item)=>item.status === "Completed"));
        setExpiredData(response.data.data.filter((item)=>item.status === "Validity-expired"));
        if(activeTab === "In-audit"){
          setCurrentData(response.data.data.filter((item)=>item.status === "Audit" || item.status === "Vendor-In-Progress"));
        }else if(activeTab === "Pending"){
          setCurrentData(response.data.data.filter((item)=>item.status === "Audit-Pending"));
        }else if(activeTab === "In-Progress"){
          setCurrentData(response.data.data.filter((item)=>item.status === "Auditor-In-progress"));
        }else if(activeTab === "Completed"){
          setCurrentData(response.data.data.filter((item)=>item.status === "Completed"));
        }else if(activeTab === "Expired"){
          setCurrentData(response.data.data.filter((item)=>item.status === "Validity-expired"));
        }
      }else{
        setCurrentData([]);
        setPendingData([]);
        setInProgressData([]);
        setCompletedData([]);
        setAuditData([]);
        setExpiredData([]);
      }
    } catch (err) {
        setCurrentData([]);
        setPendingData([]);
        setInProgressData([]);
        setCompletedData([]);
        setAuditData([]);
        setExpiredData([]);
        console.error("Failed to fetch clients:", err);
    }
  }
  useEffect(()=>{
    fetchData();
  }, [dispatch,selectedClient]);
  
  const filteredData = Array.isArray(currentData)
  ? currentData.filter(item =>
      Object.values(item).some(value =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      )
    )
  : [];

const fetchAllClient = async () => {
  try {
      const response = await dispatch(getClients());
      if (response.success) {
            setClientIDs(response.data);
      }else{
        setClientIDs([]);
      }
  } catch (err) {
      console.error("Failed to fetch clients:", err);
  }
}

useEffect(() => {
  fetchAllClient();
}, [dispatch]);

const selectedClientData = async (client_id)=>{
  setSelectedClient(client_id);
  sessionStorage.setItem("selectedAudit", client_id);
  if(client_id){
    clientIDs.filter((item)=>item.client_id === client_id)
    setSelectedClientName(clientIDs.filter((item)=>item.client_id === client_id)[0]?.client_name);
    setBlurtable('');
    
    try{
      const response = await dispatch(getUnitWiseVendor(client_id))
      if (response.success) {
        const branchList = response.data.map((item) => ({
          unit_id: item.unit_id,
          unit_name: item.unit_name,
          vendors: item.vendors || [],
        }));
        setBranches(branchList.filter((item)=>(item.vendors.length > 0)));
      }else{
        setBranches([]);
      }
    }catch(err){
      console.error(err);
    }
  }else{
    setBlurtable('blurtable');
  }
}

useEffect(() => {
  const selectedAudit = sessionStorage.getItem('selectedAudit');
  
  if (selectedAudit && clientIDs.length > 0) {
    setSelectedClient(selectedAudit);
    selectedClientData(selectedAudit);  
  }

}, [clientIDs]);
useEffect(() => {
  if (location.state) {
    if(location.state?.message){
      showSnackbar(location.state.message, location.state.type || 'success');
    }
    if(location.state.statusData === "Audit"){
      setActiveTab("In-audit");
    }else if(location.state.statusData === "Audit-Pending"){
      setActiveTab("Pending");
    }else if(location.state.statusData === "Auditor-In-progress"){
      setActiveTab("In-Progress");
    }else if(location.state.statusData === "Completed"){
      setActiveTab("Completed");
    }else if(location.state.statusData === "Validity-expired"){
      setActiveTab("Expired");
    }else{
      setActiveTab("In-audit");
    }
    window.history.replaceState({}, document.title);
  }
}, [location.state]);
const filterAuditDetailsData = async ()=>{  
  setLoading(true);
  let fromMonthFormatted = fromMonth; 
  let toMonthFormatted = toMonth;
  if(fromMonth === '' || toMonth === ''){
    showSnackbar("please enter the valid date","error")
    setLoading(false);
    return
  }
  try {
    const response = await dispatch(filteredAuditDetails(selectedClient, fromMonthFormatted, toMonthFormatted));
    if(response.success){
      setLoading(false);
      setAuditData(response.data.data.filter((item)=>item.status === "Audit" || item.status === "Vendor-In-Progress"));
      setPendingData(response.data.data.filter((item)=>item.status === "Audit-Pending"));
      setInProgressData(response.data.data.filter((item)=>item.status === "Auditor-In-progress"));
      setCompletedData(response.data.data.filter((item)=>item.status === "Completed"));
      setExpiredData(response.data.data.filter((item)=>item.status === "Validity-expired"));
      if(activeTab === "In-audit"){
        setCurrentData(response.data.data.filter((item)=>item.status === "Audit" || item.status === "Vendor-In-Progress"));
      }else if(activeTab === "Pending"){
        setCurrentData(response.data.data.filter((item)=>item.status === "Audit-Pending"));
      }else if(activeTab === "In-Progress"){
        setCurrentData(response.data.data.filter((item)=>item.status === "Auditor-In-progress"));
      }else if(activeTab === "Completed"){
        setCurrentData(response.data.data.filter((item)=>item.status === "Completed"));
      }else if(activeTab === "Expired"){
        setCurrentData(response.data.data.filter((item)=>item.status === "Validity-expired"));
      }
    }else{
      setCurrentData([]);
      setLoading(false);
    }
  } catch (err) {
      console.error("Failed to fetch clients:", err);
      setLoading(false);
  }
}

  return (
    <div className='container-fluid'>
      <div className="row mt-4">
        <div className="col-md-12">
          <div className="create-audit-header d-flex ">
          <img src={auditbreadcrumb_icon} alt="" /><h5 className='breadcrumbdata text-white'>Audit <span><GoChevronRight /></span>  Audit Details</h5>
          </div>
          <div className="row">
            <div className='container-fluid vendorEditableTable-main-contaner '>
              <div className='row FormsTable-main mb-5'>
                <div className="table-header">
                  <div className="row d-flex">
                      {/* <form onSubmit={handledeletemultialert} className='p-0 m-0'> */}
                    <div className="col d-flex justify-content-between  pe-1">
                      <div className="title-data d-flex"><div className="table_main_img"
                      //  style={{ backgroundColor: mainIconColor }} 
                      ><img src={mainIcon} alt="noImg" className='dataImg' /></div>
                        <p className="dataTitle">Audit Details</p> 
                        <div className="FormsTable-search-box position-relative">
                          <input
                            type="text"
                            className=""
                            placeholder="Search here..."
                            style={{
                              backgroundColor: "#f9fafb",
                              border: "none",
                              width: "250px"
                            }}
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                          />
                          <i
                          className="bi bi-search position-absolute"
                          style={{
                            top: "39%",
                            left: "20px",
                            transform: "translateY(-50%)",
                            color: "#9ca3af"
                          }}
                          ></i>
                        </div>
                      </div>
                      <div className='float-end d-flex'>             
                        {/* <button className={`formsTable_icon_btn ${blurtable ? blurtable : ""}`} onClick={handleDownloadSelected}><img src={download_icon} alt="noImg" className='download_icon p-0 m-0' /></button> 
                        <button className={`formsTable_icon_btn ${blurtable ? blurtable : ""}`}  onClick={handleDeleteSelected}><img src={delete_icon} alt="noImg" className='delete_icon p-0 m-0' /></button> */}
                        {/* <div className='formsTable_icon_btn'><img src={selected_icon} alt="" /></div>      */}
                          {/* <div className="formsTable_icon_btn" onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}>
                            <img src={selected_icon} alt="" />
                            {showTooltip && !blurtable && (
                                <div className="tooltipww">
                                    Selected: {checkedItemCount}
                                </div>
                            )}
                        </div> */}
                        <div className="dataTotalEntries"><p>Total Entries :{currentData?.length}</p></div>
                        <div className={`filter_or_createcomponentn d-flex `}>
                        {/* <button
                          className={`createAudit ${blurtable ? blurtable : ""}`}
                          onClick={handleToggleCreateSingleView}
                        >
                          Create Audit
                        </button> */}
                        <div className='select_clinet_create_audit'>
                          <select className='form-select' name="" id="" onChange={(e) =>selectedClientData(e.target.value)} value={selectedClient}>
                            <option value="">Organization Name</option>
                            {clientIDs?.map((client) => (
                                <option key={client.client_id} value={client.client_id}>
                                    {client.client_name}
                                </option>
                            ))}
                          </select>
                            {blurtable !=="" &&
                              <div className="tooltipAuditDetails">
                                  Select Organization Name to proceed forward
                              </div>
                            }
                        </div>
                        </div>  
                      </div>
                    </div>
                      <div className={` ${blurtable ? blurtable : ""}`}>
                      <div className="createAuditdiv d-flex justify-content-between">
                        {/* <h5>Organizationl Name : {selectedClientName && <span>{selectedClientName}</span>}</h5> */}
                        <div className="d-flex gap-3 align-items-end">
                        <div className="form-group ms-2">
                          <label>From Month</label>
                          <input type="month" className="form-control" min={minMonth} max={maxMonth} value={fromMonth} onChange={(e)=>setFromMonth(e.target.value)} />
                        </div>

                        <div className="form-group">
                          <label>To Month</label>
                          <input type="month" className="form-control" min={fromMonth} max={maxMonth} value={toMonth} onChange={(e)=>setToMonth(e.target.value)}  disabled={!fromMonth}/>
                        </div>

                        <button className="btn btn-primary" onClick={filterAuditDetailsData}>Filter</button>
                      </div>
                          <div>
                            <button className='toggle-btns'>
                                <div className="d-flex gap-2">
                                    {["In-audit","Pending", "In-Progress","Completed","Expired"].map((tab) => (
                                        <button
                                        key={tab}
                                        className={` ${activeTab === tab ? "active_btn" : "all_btn"}`}
                                        onClick={() => setActiveTab(tab)}
                                        >
                                        {tab}
                                        </button>
                                    ))}
                                </div>
                            </button>
                          </div>
                      </div>
                      <div className='table-body bg-white p-0 table-roundedData mb-3'>
                        <div
                        className={`table-responsive reuseableEditable `}
                        
                        >
                          <table className='table p-0 m-0' id='dataTable'>
                              <thead className="table-light auditDetailstHeader">
                                  <tr>
                                      {header?.map((head) => (
                                      <th key={head.key}>
                                          {head.icon && <img src={head.icon} alt="" width="16" className="me-2" />}
                                          {head.value}
                                      </th>
                                      ))}
                                  </tr>
                              </thead>
                              <tbody>
                                  {filteredData?.length > 0 ? (
                                      filteredData?.map((row) => (
                                      <tr key={row.id}>
                                          {header?.map((head) => (<>
                                            {head.value === "Action" ? <>                                            
                                              <td style={{ minWidth:"100px" }}>
                                                {head.key === "view" && (
                                                    <a className='auditActionBtn' href={`/audit-details/view/${row.id}`}>View</a>
                                                )}
                                                {head.key === "work" && (
                                                    <a className='auditActionBtn' href={`/audit-details/view-update/${row.id}`}>Work Audit</a>
                                                )}
                                                {head.key === "completed" && (
                                                    <a className='auditActionBtn' href={`/audit-details/view-completed/${row.id}`}>View</a>
                                                )}
                                                {head.key === "extend" && (
                                                    <a className='auditActionBtn' href={`/audit-details/view-expired/${row.id}`}>View and extent validity</a>
                                                )}
                                              </td>

                                            </>  :head.value === "status" ? <>                                            
                                            <td key={head.key}>
                                              <div className="audit-score-cell">
                                                <div className="d-flex align-items-center gap-1">
                                                  <span style={{ minWidth:"35px" }}>{row.audit_counts?.Compliance?.percentage || "0%"}</span>
                                                  {row.audit_counts?.Compliance?.percentage &&
                                                  <AiOutlineInfoCircle
                                                    size={18}
                                                    className="audit-info-icon"
                                                    style={{ color :"#b38417" ,cursor: "pointer"}}
                                                    onClick={(event) => handleScoreInfoClick(event, row.id)}
                                                  />
                                                  }
                                                </div>

                                                {openInfoId === row.id && tooltipPos && (
                                                  <div
                                                    className={`audit-tooltip${tooltipPos.placeAbove ? " audit-tooltip--above" : ""}`}
                                                    ref={tooltipRef}
                                                    style={{
                                                      left: tooltipPos.left,
                                                      top: tooltipPos.top,
                                                    }}
                                                  >
                                                    <div><b>Compliance:</b> {row.audit_counts.Compliance.count} ({row.audit_counts.Compliance.percentage})</div>
                                                    <div><b>Non-Compliance:</b> {row.audit_counts["Non-Compliance"].count} ({row.audit_counts["Non-Compliance"].percentage})</div>
                                                    <div><b>Not-Applicable:</b> {row.audit_counts["Not-Applicable"].count} ({row.audit_counts["Not-Applicable"].percentage})</div>
                                                  </div>
                                                )}
                                              </div>
                                            </td>

                                            </>  : Array.isArray(row[head.key])
                                                  ?<td> {row[head.key].join(", ")}</td>
                                                  : <td key={head.key}>{row[head.key] || "-"}</td> }
                                          </>
                                          ))}
                                      </tr>
                                      ))
                                  ) : (
                                      <tr>
                                      <td colSpan={header?.length} className="text-center fs-3 fw-bold text-muted">
                                        
                                        {blurtable !=="" ?<>Select The Organization Name</>:<>No Record Available</> }
                                          
                                      </td>
                                      </tr>
                                  )}
                              </tbody>
                          </table>
                        </div>
                      </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AuditDetails